"use client";
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, Heart, Search } from 'lucide-react';
import { getMenuItems, MenuItem } from '@/lib/menuItems';

export default function PublicNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [navLinks, setNavLinks] = useState<MenuItem[]>([]);

  useEffect(() => {
    setNavLinks(getMenuItems().filter((it) => it.visible));
  }, []);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-gray-100 shadow-sm">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
        <div className="flex items-center justify-between h-16">
          <Link href="/homepage" className="flex items-center gap-2.5">
            <AppLogo size={36} />
            <span className="font-display font-700 text-lg text-gray-900 hidden sm:block">
              World Giving
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks?.map((l) => (
              <Link
                key={`nav-${l?.id}`}
                href={l?.href}
                className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-all duration-150"
              >
                {l?.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button className="p-2 text-gray-500 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-all duration-150">
              <Search size={18} />
            </button>
            <Link
              href="/sign-up-login-screen"
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 border border-gray-200 rounded-xl transition-all duration-150"
            >
              Sign in
            </Link>
            <Link
              href="/sign-up-login-screen"
              className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold text-white bg-teal-600 hover:bg-teal-700 rounded-xl transition-all duration-150 active:scale-95"
            >
              <Heart size={14} />
              <span className="hidden sm:inline">Donate Now</span>
              <span className="sm:hidden">Donate</span>
            </Link>
            <button
              className="md:hidden p-2 text-gray-500 hover:bg-gray-100 rounded-lg transition-all"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </div>
      {mobileOpen && (
        <div className="md:hidden border-t border-gray-100 bg-white px-4 py-3 space-y-1 animate-fade-in">
          {navLinks?.map((l) => (
            <Link
              key={`mob-nav-${l?.id}`}
              href={l?.href}
              className="block px-4 py-2.5 text-sm font-medium text-gray-700 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-all"
              onClick={() => setMobileOpen(false)}
            >
              {l?.label}
            </Link>
          ))}
          <div className="pt-2 border-t border-gray-100 flex gap-2">
            <Link href="/sign-up-login-screen" className="flex-1 text-center py-2.5 text-sm font-semibold border border-gray-200 rounded-xl hover:bg-gray-50 transition-all">
              Sign in
            </Link>
            <Link href="/sign-up-login-screen" className="flex-1 text-center py-2.5 text-sm font-semibold text-white bg-teal-600 rounded-xl hover:bg-teal-700 transition-all">
              Register
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}